/* eslint-disable no-restricted-syntax */ function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { getInclusionDirectives } from '@apollo/client/utilities';
import { ROOT_PATH } from './enums';
const getStringObjectField = (name, value)=>({
        kind: 'ObjectField',
        name: {
            kind: 'Name',
            value: name
        },
        value: {
            kind: 'StringValue',
            value
        }
    });
export const formatStringValueNodes = (values)=>values.map((value)=>({
            kind: 'StringValue',
            value
        }));
const getFragmentListValues = (fragments)=>{
    const values = [];
    for (const [fragmentName, paths] of fragments.entries()){
        values.push({
            kind: 'ObjectValue',
            fields: [
                {
                    kind: 'ObjectField',
                    name: {
                        kind: 'Name',
                        value: 'name'
                    },
                    value: {
                        kind: 'StringValue',
                        value: fragmentName
                    }
                },
                {
                    kind: 'ObjectField',
                    name: {
                        kind: 'Name',
                        value: 'paths'
                    },
                    value: {
                        kind: 'ListValue',
                        values: formatStringValueNodes(paths)
                    }
                }
            ]
        });
    }
    return values;
};
export const getFragmentParams = (fragments)=>{
    const values = getFragmentListValues(fragments);
    return {
        kind: 'Argument',
        name: {
            kind: 'Name',
            value: 'fragments'
        },
        value: {
            kind: 'ListValue',
            values
        }
    };
};
const getPathParams = (type, pathParams)=>{
    const values = formatStringValueNodes(pathParams);
    return {
        kind: 'Argument',
        name: {
            kind: 'Name',
            value: type
        },
        value: {
            kind: 'ListValue',
            values
        }
    };
};
export const getIncludeOnlyParams = (includeOnly)=>getPathParams('includeOnly', includeOnly);
export const getExpandParams = (expands)=>getPathParams('expand', expands);
export const getNodeLookupMapParams = (nodeLookupMap)=>{
    const values = [];
    for (const path of Object.keys(nodeLookupMap)){
        values.push({
            kind: 'ObjectValue',
            fields: [
                {
                    kind: 'ObjectField',
                    name: {
                        kind: 'Name',
                        value: 'nodes'
                    },
                    value: {
                        kind: 'ListValue',
                        values: formatStringValueNodes(nodeLookupMap[path])
                    }
                },
                getStringObjectField('parentPath', path)
            ]
        });
    }
    return {
        kind: 'Argument',
        name: {
            kind: 'Name',
            value: 'nodeLookupMap'
        },
        value: {
            kind: 'ListValue',
            values
        }
    };
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const getListObjectField = (name, values)=>({
        kind: 'ObjectField',
        name: {
            kind: 'Name',
            value: name
        },
        value: {
            kind: 'ListValue',
            values
        }
    });
const getConditionalNodeParams = (node)=>{
    const baseFields = [
        getStringObjectField('type', node.type),
        getStringObjectField('path', node.path),
        getStringObjectField('variable', node.variable),
        getListObjectField('includeOnly', formatStringValueNodes(node.includeOnly)),
        getStringObjectField('expand', node.expand),
        getListObjectField('fragments', getFragmentListValues(node.fragments))
    ];
    if (node.children.length === 0) {
        return {
            kind: 'ObjectValue',
            // @ts-expect-error - TS2322 - Type 'ObjectFieldNode | { kind: string; name: { kind: string; value: string; }; value: { kind: string; values: any[]; }; }' is not assignable to type 'ObjectFieldNode'. | TS2322 - Type '{ kind: string; name: { kind: string; value: string; }; value: { kind: string; values: any[]; }; }' is not assignable to type 'ObjectFieldNode'.
            // eslint-disable-next-line @stripe-internal/stripe/no-props-suppress-errors
            fields: [
                ...baseFields,
                getListObjectField('children', [])
            ]
        };
    }
    return {
        kind: 'ObjectValue',
        fields: [
            // @ts-expect-error - TS2322 - Type 'ObjectFieldNode | { kind: string; name: { kind: string; value: string; }; value: { kind: string; values: any[]; }; }' is not assignable to type 'ObjectFieldNode'.
            ...baseFields,
            // @ts-expect-error - TS2322 - Type '{ kind: string; name: { kind: string; value: string; }; value: { kind: string; values: any[]; }; }' is not assignable to type 'ObjectFieldNode'.
            getListObjectField('children', node.children.map(getConditionalNodeParams))
        ]
    };
};
export const getPredicatesParams = (predicates)=>{
    if (predicates.ROOT.children.length === 0) {
        return {
            kind: 'Argument',
            name: {
                kind: 'Name',
                value: 'predicates'
            },
            value: {
                kind: 'ObjectValue',
                fields: []
            }
        };
    }
    return {
        kind: 'Argument',
        name: {
            kind: 'Name',
            value: 'predicates'
        },
        value: {
            kind: 'ObjectValue',
            fields: [
                {
                    kind: 'ObjectField',
                    name: {
                        kind: 'Name',
                        value: 'ROOT'
                    },
                    value: {
                        kind: 'ObjectValue',
                        fields: [
                            // @ts-expect-error - TS2322 - Type '{ kind: string; name: { kind: string; value: string; }; value: { kind: string; values: any[]; }; }' is not assignable to type 'ObjectFieldNode'.
                            getListObjectField('children', predicates.ROOT.children.map(getConditionalNodeParams)),
                            // @ts-expect-error - TS2322 - Type '{ kind: string; name: { kind: string; value: string; }; value: { kind: string; values: any[]; }; }' is not assignable to type 'ObjectFieldNode'.
                            getListObjectField('variables', formatStringValueNodes(predicates.ROOT.variables))
                        ]
                    }
                }
            ]
        }
    };
};
export const getPathInfo = (path)=>{
    const segments = path.split('.');
    let parentPath = segments.slice(0, -1).join('.');
    if (parentPath === '') {
        parentPath = ROOT_PATH;
    }
    return {
        parentPath,
        nodeName: segments[segments.length - 1]
    };
};
export const bucketNodesByPath = (includes)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const nodeLookup = {};
    includes.forEach((include)=>{
        const { parentPath, nodeName } = getPathInfo(include);
        const childNodes = nodeLookup[parentPath];
        if (!childNodes) {
            nodeLookup[parentPath] = [];
        }
        // bucket fields by their parents
        if (!nodeLookup[parentPath].includes(nodeName)) {
            nodeLookup[parentPath].push(nodeName);
        }
    });
    return nodeLookup;
};
export const appendDecisionTreeNode = (tree, targetNode)=>{
    let current = tree.ROOT;
    const { path: targetpath } = targetNode;
    if (!tree.ROOT.variables.includes(targetNode.variable)) {
        tree.ROOT.variables.push(targetNode.variable);
    }
    let notFound = true;
    while(notFound){
        const parentNode = current.children.find(// synthetic node should not have any children
        (node)=>targetpath.startsWith(node.path) && !node.synthetic);
        if (parentNode) {
            // @ts-expect-error - TS2741 - Property 'variables' is missing in type 'ConditionalNode' but required in type '{ variables: string[]; children: ConditionalNode[]; }'.
            current = parentNode;
        } else {
            current.children.push(targetNode);
            notFound = false;
        }
    }
};
const findParentNode = (node, targetPath)=>{
    if (node.path === targetPath) {
        return node;
    }
    const current = node.children.find(({ path })=>targetPath.startsWith(path));
    if (!current) {
        if (targetPath.startsWith(node.path)) {
            return node;
        }
        return null;
    }
    return findParentNode(current, targetPath);
};
const insertIncludeOnlyToDecisionTree = (tree, includeOnly)=>{
    includeOnly.forEach((include)=>{
        for (const topLevelNode of tree.ROOT.children){
            const node = findParentNode(topLevelNode, include);
            if (node) {
                // if the target path belongs to the current top-level field
                node.includeOnly.push(include);
                break;
            }
        }
    });
};
const markPath = (node, targetPath)=>{
    const isSubPath = targetPath.startsWith(node.path);
    if (isSubPath) {
        // if the current path is a subpath of the fully expanded path
        // append the current path as the partially expanded path first
        node.expand = node.path;
    }
    // In the case of synthetic nodes, we might have multiple sibling nodes with the same path
    const current = node.children.filter(({ path })=>targetPath.startsWith(path));
    if (!current.length) {
        if (isSubPath) {
            // append the fully expanded path if the current path is the last conditional directive
            // on the expand path
            node.expand = targetPath;
        }
        return;
    }
    current.map((eachMatch)=>markPath(eachMatch, targetPath));
};
const insertExpandsToDecisionTree = (tree, expands)=>{
    expands.forEach((expand)=>{
        tree.ROOT.children.forEach((topLevelNode)=>markPath(topLevelNode, expand));
    });
};
/**
 * When a FragmentSpread node is directly annotated by @skip or @include we
 * need to perform further evaluation on the inline FragmentSpread predicate in
 * addition to the ancestor predicates.
 *
 * The solution proposed here is simply creating a "Synthetic" decision tree
 * node where the predicate information is carried over and only contains the
 * conditional fragment info.
 */ const getSyntheticNode = ({ parentPath, fragmentName }, inlinePredicate)=>{
    const fragments = new Map([
        [
            fragmentName,
            [
                parentPath
            ]
        ]
    ]);
    return {
        type: inlinePredicate.type,
        variable: inlinePredicate.variable,
        path: parentPath,
        includeOnly: [],
        expand: '',
        fragments,
        children: [],
        synthetic: true
    };
};
const insertFragmentNodeToDecisionTree = (tree, { fragmentName, parentPath })=>{
    for (const topLevelNode of tree.ROOT.children){
        const node = findParentNode(topLevelNode, parentPath);
        if (node) {
            const existingPaths = node.fragments.get(fragmentName) || [];
            if (!existingPaths.includes(parentPath)) {
                node.fragments.set(fragmentName, [
                    ...existingPaths,
                    parentPath
                ]);
            }
            break;
        }
    }
};
const insertFragmentsToDecisionTree = (tree, fragments)=>{
    for (const [fragmentName, paths] of fragments.entries()){
        paths.forEach(({ parentPath, inlinePredicate })=>{
            const fragmentNode = {
                fragmentName,
                parentPath
            };
            if (inlinePredicate) {
                const syntheticNode = getSyntheticNode(fragmentNode, inlinePredicate);
                appendDecisionTreeNode(tree, syntheticNode);
            } else {
                insertFragmentNodeToDecisionTree(tree, fragmentNode);
            }
        });
    }
};
// TODO: Consolidate all decision tree related methods into its own class.
export const updateDecisionTree = (tree, includeOnly, expands, fragments)=>{
    insertIncludeOnlyToDecisionTree(tree, includeOnly);
    insertFragmentsToDecisionTree(tree, fragments);
    insertExpandsToDecisionTree(tree, expands);
};
export const hasConditionalDirectives = (stack)=>{
    const nodes = stack.map(({ node })=>node).filter(Boolean);
    const directives = getInclusionDirectives(nodes.flatMap((node)=>(node === null || node === void 0 ? void 0 : node.directives) || []));
    if (directives.length) {
        return true;
    }
    return false;
};
export const getInlinePredicate = (directives, nodePath)=>{
    const inclusionDirectives = getInclusionDirectives(directives);
    if (inclusionDirectives.length) {
        if (inclusionDirectives.length > 1) {
            throw new Error(`Please only specific a single inclusion directive for ${nodePath}`);
        }
        const { directive, ifArgument } = inclusionDirectives[0];
        // @ts-expect-error - TS2339 - Property 'name' does not exist on type 'ValueNode'.
        const inputVariable = ifArgument.value.name.value;
        return {
            type: directive.name.value,
            variable: inputVariable
        };
    }
};
// Get v1Context variable defintion from operation node.
const getOverrides = (operationNode)=>{
    var _operationNode_variableDefinitions;
    return (_operationNode_variableDefinitions = operationNode.variableDefinitions) === null || _operationNode_variableDefinitions === void 0 ? void 0 : _operationNode_variableDefinitions.find((v)=>v.type.kind === 'NonNullType' && v.type.type.kind === 'NamedType' && v.type.type.name.value === 'V1ContextInput');
};
// If v1Context are already present as argument to operation, do nothing
// else, add them.
export const ensureOverridesToOperation = (operationNode)=>{
    // Check if v1Context are already present.
    if (getOverrides(operationNode)) {
        return operationNode;
    }
    // Add v1Context to variable definitions.
    const v1ContextDefinitionNode = {
        kind: 'VariableDefinition',
        variable: {
            kind: 'Variable',
            name: {
                kind: 'Name',
                value: 'v1Context'
            }
        },
        type: {
            kind: 'NonNullType',
            type: {
                kind: 'NamedType',
                name: {
                    kind: 'Name',
                    value: 'V1ContextInput'
                }
            }
        }
    };
    const variableDefinitions = [
        ...operationNode.variableDefinitions || [],
        v1ContextDefinitionNode
    ];
    return _object_spread_props(_object_spread({}, operationNode), {
        variableDefinitions
    });
};
// If v1Context are already present as argument to top-level field, do nothing
// else, add them.
export const ensureOverridesToField = (node, operationNode)=>{
    var _node_arguments;
    const v1Context = getOverrides(operationNode);
    // Should not happen, because ensureOverridesToOperation should have already
    // been called.
    if (!v1Context) {
        throw new Error(`Overrides missing from graphql operation: ${operationNode}`);
    }
    // Check if v1Context is already present on the field.
    if ((_node_arguments = node.arguments) === null || _node_arguments === void 0 ? void 0 : _node_arguments.some((arg)=>arg.value.kind === 'Variable' && arg.value.name.value === v1Context.variable.name.value)) {
        return node;
    }
    const v1ContextArgumentNode = {
        kind: 'Argument',
        name: v1Context.variable.name,
        value: v1Context.variable
    };
    const args = node.arguments ? [
        ...node.arguments,
        v1ContextArgumentNode
    ] : [
        v1ContextArgumentNode
    ];
    return _object_spread_props(_object_spread({}, node), {
        arguments: args
    });
};

//# sourceMappingURL=utils.js.map